import { useState } from "react";
import { OptionType } from "@shared/ui/Select";
import { orgInvitationEventBus } from "../orgInvitation.events";
import useGetOrganizations from "@shared/hooks/useGetOrganizations";

type Props = {
  onClose?: () => void;
  shouldLoad?: boolean;
};

export function useOrgLookup({ onClose, shouldLoad = false }: Props) {
  const { options, setOptions, isLoading } = useGetOrganizations({
    shouldLoad,
  });

  const [selectedOptions, setSelectedOptions] = useState<OptionType[]>([]);

  const [selectedOrg, setSelectedOrg] = useState<OptionType | null>(null);

  const handleSelectOrganization = (newOption: OptionType) => {
    setSelectedOptions((prev) => {
      const exists = prev.some((opt) => opt.value === newOption.value);
      return exists ? prev : [...prev, newOption];
    });

    setSelectedOrg(null);
  };

  const handleCreateOrganization = (inputValue: string) => {
    const newOption = {
      label: inputValue,
      value: `${inputValue.toLowerCase().replace(/\s+/g, "-")}`,
      data: { created: true },
    };

    setOptions((prev) => {
      const exists = prev.some((opt) => opt.label === newOption.label);
      return exists ? prev : [...prev, newOption];
    });

    setSelectedOptions((prev) => [...prev, newOption]);

    orgInvitationEventBus.emitEvent("lookupOrg:notFound", { name: inputValue });

    setSelectedOrg(null);
  };

  const handleClose = () => {
    setSelectedOptions([]);
    setSelectedOrg(null);
    onClose?.();
  };

  return {
    handleClose,
    handleSelectOrganization,
    handleCreateOrganization,
    options,
    isLoading,
    selectedOptions,
    selectedOrg,
  };
}

export default useOrgLookup;
